import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var DisplayObjectEvent = /** @class */ (function (_super) {
    __extends(DisplayObjectEvent, _super);
    function DisplayObjectEvent(type, object) {
        var _this = _super.call(this, type) || this;
        _this._object = object;
        return _this;
    }
    Object.defineProperty(DisplayObjectEvent.prototype, "object", {
        get: function () {
            return this._object;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    DisplayObjectEvent.prototype.clone = function () {
        return new DisplayObjectEvent(this.type, this._object);
    };
    /**
     *
     */
    DisplayObjectEvent.VISIBLITY_UPDATED = 'visiblityUpdated';
    /**
     *
     */
    DisplayObjectEvent.SCENETRANSFORM_CHANGED = 'scenetransformChanged';
    /**
     *
     */
    DisplayObjectEvent.PARTITION_CHANGED = 'partitionChanged';
    return DisplayObjectEvent;
}(EventBase));
export { DisplayObjectEvent };
